import * as React from "react";
import { RewardsLoginIcon } from "../MyAccount/MyRewardProfile/reward-sign-image";
import { JoinDrawer, NavigationBar } from "../Common";

import {
  ContentRoutes,
  useContentRoute,
  useReactJoinInitialState,
} from "./providers";

import { PageJoin } from "./page-join";
import { PageLogin } from "./page-login";
import { RewardsDetailsColumn } from "./rewards-details-column";
import { AppLoading } from "./app-loading";
import { TopMessages } from "./top-messages";

export const Page: React.FunctionComponent = () => {
  const {
    hasInitialized,
    selectedContentRoute,
    onUserWantsToSelectContentRoute,
  } = useContentRoute();

  return (
    <section className="bbnt-join-login-page">
      <AppLoading />
      <TopMessages />

      <div
        className={
          selectedContentRoute === ContentRoutes.Join
            ? "content"
            : "content login"
        }
      >
        <div className="to-hide-sign-image">
          {selectedContentRoute === ContentRoutes.Login && <RewardsLoginIcon />}
        </div>

        <div className="left">
          {hasInitialized && (
            <React.Fragment>
              <NavigationBar
                ContentRoutes={ContentRoutes}
                selectedContentRoute={selectedContentRoute}
                onUserWantsToSelectContentRoute={
                  onUserWantsToSelectContentRoute as (route: string) => void
                }
              />
              {selectedContentRoute === ContentRoutes.Join && <PageJoin />}
              {selectedContentRoute === ContentRoutes.Login && <PageLogin />}
            </React.Fragment>
          )}
        </div>
        <div className="right">
          <RewardsDetailsColumn />
        </div>
      </div>
      <JoinDrawer useInitialState={useReactJoinInitialState} allowJoining />
    </section>
  );
};
